import axios, { POST } from './axios';
import getSessionUser from './getSessionUser';
import { l } from '@insight/toolkit-utils';
import { getThirdPartyWarranties } from './getThirdPartyWarranties';
import { formatToProtectionPlan } from '../lib/warranties';
import { getRequestForRecommendationsApi } from './getRequestForRecommendationsApi';
import { getProductDetailsCachedData } from './getProductDetails';
import { isEmeaRegion } from '@insight/toolkit-utils/lib/helpers/localeHelpers';

export const getNonIpsRecommendations = async (
  productId,
  byPassError,
  salesOrg
) => {
  try {
    const {
      rrApiUrl,
      userInformation,
      isLoggedIn: loggedin,
    } = await getSessionUser()
    const { currencyCode } = userInformation || {}
    const locale = l()
    const placementIds = 'item_page.rr_warranties|item_page.rr_accessories' +
      '|item_page.rr2_recommends|item_page.rr2_recommends_qa' +
      '|item_page.rr3_recommends'

    const body = await getRequestForRecommendationsApi(
      placementIds,
      productId,
      false
    )
    let url = '/gapi/product-management/getRecommendations'
    const { data } = await axios({
      method: POST,
      url: url,
      data: body,
    })

    let availableCarriers = null
    const isLoggedOutDefault =
      window?.flags &&
      window?.flags['GNA-10394-SHOPPING-CART'] &&
      !loggedin &&
      locale.split('_')[1] === 'US'
    const isUS = locale?.split('_')?.[1] === 'US'
    const isCA = locale?.split('_')?.[1] === 'CA'
    const isCarrierEnable =
      !isLoggedOutDefault &&
      (isUS || isCA) &&
      window?.flags['GNA-13803-CELLULAR-CARRIER-ACTIVATION']
    if (isCarrierEnable) {
      const cachedProduct = await getProductDetailsCachedData({
        materialId: productId,
        locale,
        salesOrg,
        userInformation,
        isLoggedIn: loggedin
      })
      availableCarriers = cachedProduct?.product?.availableCarriers;
    }
    // Extensive checks due to having to reduce the response
    if (!Array.isArray(data) || !data.length) {
      if (byPassError) return {}
      throw new Error('Error finding placements')
    }
    // Reduce recommendations array to object
    const recommendationsArray = data?.reduce(
      (obj, cur) => ({
        ...obj,
        [cur.placementId]: cur,
      }),
      {}
    )

    // Get 3rd party warranties only for US for now
    let isUSLocale = locale && locale.split('_')[1] === 'US'
    if (loggedin) {
      isUSLocale = isUSLocale && currencyCode === 'USD'
    }
    const thirdPartyList = isUSLocale
      ? await getThirdPartyWarranties(productId, salesOrg)
      : []
    const thirdPartyProtection = thirdPartyList?.length
      ? thirdPartyList?.map(formatToProtectionPlan)
      : thirdPartyList

    let isRrIntegration = rrApiUrl?.includes('integration')
    if (isEmeaRegion()) {
      return {
        accessories: recommendationsArray['item_page.rr_accessories'],
        protection: recommendationsArray['item_page.rr_warranties'],
        thirdPartyProtection,
        better_together: isRrIntegration
          ? recommendationsArray['item_page.rr2_recommends']
          : recommendationsArray['item_page.rr2_recommends'] ||
          recommendationsArray['item_page.rr2_recommends_qa'],
        bought_together: isRrIntegration
          ? recommendationsArray['item_page.rr2_recommends_qa']
          : recommendationsArray['item_page.rr3_recommends'],
        availableCarriers,
      }
    } else {
      return {
        accessories: recommendationsArray['item_page.rr_accessories'],
        protection: recommendationsArray['item_page.rr_warranties'],
        thirdPartyProtection,
        better_together:
          recommendationsArray['item_page.rr2_recommends'] ||
          recommendationsArray['item_page.rr2_recommends_qa'],
        bought_together: recommendationsArray['item_page.rr3_recommends'],
        availableCarriers,
      }
    }
  } catch (err) {
    if (err?.response?.data?.message)
      err = new Error(err?.response?.data?.message)
    console.warn(`Failed to fetch placements`, err)
  }
}
